module.exports = __webpack_public_path__ + "static/media/habits-icon.33763eba.svg";